import { render, staticRenderFns } from "./add-clinic.vue?vue&type=template&id=698b1a42&scoped=true&"
import script from "./add-clinic.vue?vue&type=script&lang=js&"
export * from "./add-clinic.vue?vue&type=script&lang=js&"
import style0 from "./add-clinic.vue?vue&type=style&index=0&id=698b1a42&scoped=true&lang=css&"
import style1 from "./add-clinic.vue?vue&type=style&index=1&id=698b1a42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698b1a42",
  null
  
)

export default component.exports